var render = function () {
  var _vm$value$thumb;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "tile": "",
      "to": "/programs/".concat(_vm.value._id)
    }
  }, [_c('v-card', {
    staticClass: "mb-24",
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, [_c('v-img', {
    staticClass: "grey-f7",
    attrs: {
      "src": (_vm$value$thumb = _vm.value.thumb) === null || _vm$value$thumb === void 0 ? void 0 : _vm$value$thumb.src,
      "aspect-ratio": 282 / 438
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('v-overlay', {
          attrs: {
            "absolute": "",
            "light": "",
            "color": "white"
          }
        }, [_c('image-overlay', [_vm._v(_vm._s(_vm.value.host.name))])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('div', {
    staticClass: "mb-24"
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8"
  }, [_vm._v(_vm._s(_vm.value.subject))]), _c('div', [_c('p', {
    staticClass: "page-text primary--text mb-4"
  }, [_vm._v(_vm._s(_vm.value.host.name))]), _c('p', {
    staticClass: "page-text ma-0"
  }, [_vm._v(_vm._s(_vm.value.date.programDisplay.text))])])]), _c('v-chip-group', [_c('v-chip', {
    attrs: {
      "outlined": "",
      "label": ""
    }
  }, [_c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" " + _vm._s(_vm.value._employees.length.format()) + "명 참여 ")])]), _c('v-chip', {
    attrs: {
      "outlined": "",
      "label": ""
    }
  }, [_c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" " + _vm._s(_vm.value._employers.length.format()) + "개 기업 참여 ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }